import { GOOGLE_MAPS_API_KEY } from '../../shared/constants'

export const PLACES_API_IS_LOADING = 'ksk001/google/PLACES_API_IS_LOADING'
export const PLACES_API_IS_LOADED = 'ksk001/google/PLACES_API_IS_LOADED'

export const initialState = {
  placesIsLoaded: false,
}

export default (state = initialState, action) => {
  const { type } = action

  switch (type) {
    case PLACES_API_IS_LOADING:
      return {
        ...state,
        placesIsLoading: true,
      }
    case PLACES_API_IS_LOADED:
      return {
        ...state,
        placesIsLoading: false,
        placesIsLoaded: true,
      }
    default:
      return state
  }
}

export const loadGooglePlaces = () => async (dispatch, getState) => {
  const state = getState()
  const isLoading = state.google.placesIsLoading
  const isLoaded = state.google.placesIsLoaded

  if (!isLoading && !isLoaded) {
    dispatch({
      type: PLACES_API_IS_LOADING,
    })

    await loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`
    )

    dispatch({
      type: PLACES_API_IS_LOADED,
    })
  }
}

const loadScript = async scriptUrl => {
  const script = document.createElement('script')
  script.src = scriptUrl
  document.body.appendChild(script)

  return new Promise((res, rej) => {
    script.onload = function () {
      res()
    }
    script.onerror = function () {
      rej()
    }
  })
}
